import { useTranslation } from "react-i18next"

import { DeleteFloorOverlayModel } from "../DeleteFloorOverlay"

export interface DeleteFloorOverlayViewModel {
  headline: string
  confirmButtonText: string
  checkboxConfirmationLabel: string
  floorLabel: string
  onDelete: () => void
  onClose: () => void
}

export function useDeleteFloorOverlayViewModel({
  floor,
  onDelete,
  onClose
}: DeleteFloorOverlayModel): DeleteFloorOverlayViewModel {
  const { t } = useTranslation()

  const floorLabel = floor?.label || ""

  return {
    headline: t("Floor.DeleteCheckboxConfirmationMessage"),
    confirmButtonText: t("General.Delete"),
    checkboxConfirmationLabel: t("Floor.DeleteCheckboxConfirmationLabel"),
    floorLabel,
    onDelete,
    onClose
  }
}
